import './App.css';
import axios from 'axios';
import React, { useState, useEffect } from 'react';

function App() {
  const [city, setCity] = useState('');
  const [weatherData, setWeatherData] = useState(null);
  const [error, setError] = useState('');

  const apiKey = 'ac0ecf7ab84654f65480d8fbb131530a';

  const handleChange = (event) => {
    setCity(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setWeatherData(null);

    if (!city) {
      setError('Please enter a city!');
      return;
    }

    try {
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}`
      );
      setWeatherData(response.data);
    } catch (err) {
      setError('City not found');
    }
  };

  useEffect(() => {
    if (!weatherData) {
      document.body.style.backgroundImage = "url('/images/back1.jpg')";
      return;
    }

    const main = weatherData.weather[0].main.toLowerCase();
    let bg = '/images/default.jpg';

    if (main.includes('cloud')) bg = '/public/images/cloudy.jpg';
    else if (main.includes('rain') || main.includes('drizzle')) bg = '/public/images/rainy.jpg';
    else if (main.includes('snow')) bg = '/public/images/snowy.jpg';
    else if (main.includes('clear')) bg = '/public/images/sunny.jpg';
    else if (main.includes('thunderstorm')) bg = '/public/images/thunder.jpg';

    document.body.style.backgroundImage = `url(${bg})`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.backgroundRepeat = 'no-repeat';
  }, [weatherData]);

  return (
    <div>
      <div className="weather-search-container">
        <h1 className="heading-main">Weather App</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={city}
            onChange={handleChange}
            placeholder="Enter city name"
          />
          <button type="submit">Search</button>
        </form>

        {error && <p className="error">{error}</p>}

        {weatherData && (
          <div className="weather-result">
            <h2>{weatherData.name}</h2>
            <img
              src={`https://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`}
              alt="weather icon"
            />
            <p>Temperature: {(weatherData.main.temp - 273.15).toFixed(1)} °C</p>
            <p>Weather: {weatherData.weather[0].description}</p>
            <p>Country: {weatherData.sys.country}</p>
          </div>
        )}
      </div>

      <div className="jaison">
        <a
          href="https://www.linkedin.com/in/jaison-jaideep-lobo/"
          target="_blank"
          rel="noreferrer"
        >
          Developed By ~ Kishore
        </a>
      </div>
    </div>
  );
}

export default App;
